<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">內外傷病紀錄登記</span>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Time" id="Time" label="時間(24小時制)" type="time" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.No" id="No" label="學號/工號" type="text" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.Place" id="Place" label="受傷地點" required>
                    <slot name="place"></slot>
                </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.LeftTime" id="LeftTime" label="離開時間(24小時制)" type="time" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Contact" id="Contact" label="聯絡方式" type="text" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
                <div class="form-group">
                    <span class="text-danger">*</span>
                    <label>受傷部位</label>
                    <label class="form-control" v-for="item in area" :key="item.key">
                        <input type="checkbox" v-model="vm.InjuredArea" :value="item.key" />{{item.value}}
                    </label>
                    <form-input v-model="vm.InjuredAreaOther" id="InjuredAreaOther" placeholder="其他" type="text"></form-input>
                </div>
            </div>
            <div class="col-md-3 col-sm-12">
                <form-input v-model="vm.Reason" id="Reason" label="受傷原因" type="text" required>
                    <template slot="list">
                        <div is="option" v-for="item in reason" :key="item.key" :value="item.value"></div>
                    </template>
                </form-input>
            </div>
            <div class="col-md-3 col-sm-12">
                <div class="form-group">
                    <span class="text-danger">*</span>
                    <label>受傷性質/症狀</label>
                    <label class="form-control" v-for="item in kind" :key="item.key">
                        <input type="checkbox" v-model="vm.InjuredKind" :value="item.key" />{{item.value}}
                    </label>
                    <form-input v-model="vm.InjuredKindOther" id="InjuredKindOther" placeholder="其他" type="text"></form-input>
                </div>
            </div>
            <div class="col-md-3 col-sm-12">
                <div class="form-group">
                    <span class="text-danger">*</span>
                    <label>處理方式</label>
                    <label class="form-control" v-for="item in treatment" :key="item.key">
                        <input type="checkbox" v-model="vm.Treatment" :value="item.key" />{{item.value}}
                    </label>
                    <form-input v-model="vm.TreatmentOther" id="TreatmentOther" placeholder="其他" type="text"></form-input>
                </div>
            </div>
            <div class="col-12">
                <form-textarea v-model="vm.Remark" id="Remark" label="備註" type="text"></form-textarea>
            </div>
        </div>
    </modal>
</template>

<script>
    const now = new Date();
    const time = `${window.padLeft(now.getHours(), 2)}:${window.padLeft(now.getMinutes(), 2)}`;

    import { detail } from '@/views';
    export default detail({
        name: 'injuryrecordDetail',
        api: '/api/injuryrecord/',
        data: { area: [], reason: [], kind: [], treatment: [] },
        vm: { Date: now, Time: time, InjuredArea: [], InjuredKind: [], Treatment: [] },
        showntransform: function (data) {
            data = JSON.parse(data);
            data.InjuredArea = data.InjuredArea ? data.InjuredArea.split(',') : [];
            data.InjuredKind = data.InjuredKind ? data.InjuredKind.split(',') : [];
            data.Treatment = data.Treatment ? data.Treatment.split(',') : [];
            if (data.LeftTime) {
                data.LeftTime = new Date(data.LeftTime);
                data.LeftTime = `${window.padLeft(data.LeftTime.getHours(), 2)}:${window.padLeft(data.LeftTime.getMinutes(), 2)}`;
            }
            return data;
        },
        savetransform: function (data) {
            let newobj = Object.assign({}, data);
            newobj.InjuredArea = data.InjuredArea.join();
            newobj.InjuredKind = data.InjuredKind.join();
            newobj.Treatment = data.Treatment.join();
            return newobj;
        },
        created: function () {
            this.$parameter.injuryarea().then((res) => { this.area = res.data; });
            this.$parameter.injuryreason().then((res) => { this.reason = res.data; });
            this.$parameter.injurykind().then((res) => { this.kind = res.data; });
            this.$parameter.injurytreatment().then((res) => { this.treatment = res.data; });
        },
    });
</script>

<style>
</style>